import { render, staticRenderFns } from "./PackageLimitDialog.vue?vue&type=template&id=45310485"
import script from "./PackageLimitDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageLimitDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PackageLimitDialog.vue?vue&type=style&index=0&id=45310485&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports